export default __webpack_public_path__ + "static/media/trx-icon.5070e9e7.svg";